import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Translation } from 'react-i18next'
import { useForm, Form, Field, WatchField, useWatch } from '../../form'
import { decisionDialogValidate } from '../../containers/validate'
import Button from '@material-ui/core/Button'
import { MenuItem, Snackbar } from '@material-ui/core'
import AddToInvoice from './addToInvoice.component'
import DateTimeFormat from '../../utils/DateTimeFormat'
import { convertIntToState } from '../../utils/invoice.utils'
import { editInvoice, showInvoiceFormDialog } from '../../actions'
import mobileView from '../../utils/mobile.utils'
import { MySnackbarContentWrapper } from '../../utils/snackbar.utils'

class AddToInvoiceDialog extends React.Component {
  render() {
    return <AddToInvoiceDialogComponent {...this.props} />
  }
}

const styles = (theme) => ({
  button: {
    margin: theme.spacing(1),
    [theme.breakpoints.down('380')]: {
      width: '90%',
      margin: '8px 15px'
    }
  },
  select: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    cursor: 'pointer',
    fontSize: '14px',
    borderBottom: '1px solid gray',
    [theme.breakpoints.down('380')]: {
      fontSize: '10px'
    }
  },
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray'
  },
  resize: {
    fontSize: '14px'
  },
  checkbox: {
    marginTop: theme.spacing(3),
    fontSize: '15px',
    fontWeight: 'bold',
    marginLeft: '15px',
    color: '#808080'
  },
  radioButton: {
    marginTop: theme.spacing(3),
    fontSize: '15px',
    fontWeight: 'bold',
    marginLeft: '15px',
    color: '#808080'
  }
})

const defaultValues = {
  decisionSelect: 'add_to_invoice',
  invoice_group: ''
}

const AddToInvoiceDialogComponent = ({
  classes,
  type,
  cancelDialog,
  addToInvoice,
  selected,
  clearSelection,
  updateToInvoice,
  hasInvalidSelectedAllowance = false
}) => {
  const history = useHistory()

  const dispatch = useDispatch()
  const invoices = useSelector((state) => state.invoice.invoices)

  const validInvoiceDrafts = invoices.filter((el) => el.status === 0)
  let invoicesDraft = validInvoiceDrafts.map((item, index) =>
    generateMenuItem(item, index)
  )

  let validInvoicesAll = invoices.filter(
    (el) =>
      (el.status === 2 || el.status === 24 || el.status === 5) && // Paid || Paid (MP) || Loaned
      el.partial_invoice_id < 2 &&
      el.is_group_invoice === 0 &&
      (el.invoicepaid === 0 || el.invoicepaid === 1)
  )

  let invoicesAll = validInvoicesAll.map((item, index) =>
    generateMenuItem(item, index)
  )

  const form = useForm({
    name: 'decisionDialog',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    validator: decisionDialogValidate,
    mode: 'onChange',
    resetOnSubmit: false
  })

  const { control, setValue } = form

  function onSubmit(values) {
    if (values.decisionSelect === 'add_to_invoice') {
      if (values.invoice_group === 'NewInvoice') {
        cancelDialog()
        history.push('/dashboard/invoice')
        dispatch(showInvoiceFormDialog())
        addToInvoice(selected, null)
      } else {
        cancelDialog()
        history.push('/dashboard/invoice')
        dispatch(showInvoiceFormDialog())
        dispatch(editInvoice(values.invoice_group, { [type]: selected }))
      }
    } else {
      updateToInvoice(values.invoice_group, values.decisionSelect, selected)
      clearSelection()
    }
  }

  function cancel(e) {
    cancelDialog(e)
  }

  function clearInvoiceSelection() {
    setValue('invoice_group', '')
  }

  const { decisionSelect } = useWatch({
    fields: ['decisionSelect'],
    control: control
  })

  return (
    <Translation>
      {(t) => (
        <div
          style={{
            width: '100%'
          }}
        >
          <Form {...form}>
            <div className="container-fluid">
              <div className="row">
                <div className="dashboard-content-header">
                  <div className="panel panel-default">
                    <div className="panel-heading">
                      <h3 className="panel-title">
                        {type === 'expense'
                          ? t('decisionDialog.dialogTitle')
                          : t('decisionDialog.dialogTitle1')}
                      </h3>
                    </div>
                    <div className="panel-body">
                      <AddToInvoice
                        classes={classes}
                        type={type}
                        control={control}
                        onChange={clearInvoiceSelection}
                        hideButton
                      />
                      <WatchField control={control} fields="decisionSelect">
                        {(watch) =>
                          (watch.decisionSelect === 'add_to_payroll' ||
                            watch.decisionSelect === 'add_to_invoice') && (
                            <div>
                              <Field
                                name="invoice_group"
                                inputType="select"
                                control={control}
                                label={
                                  type === 'expense'
                                    ? t('decisionDialog.invoiceGroup')
                                    : t('decisionDialog.invoiceGroup1')
                                }
                                style={{
                                  marginTop: mobileView ? '40px' : null
                                }}
                                className={classes.select}
                              >
                                {watch.decisionSelect === 'add_to_invoice' ? (
                                  <MenuItem
                                    key={'newInvoice'}
                                    value={'NewInvoice'}
                                  >
                                    {t('expences.addInfoToNewInvoiceBtn')}
                                  </MenuItem>
                                ) : null}
                                {watch.decisionSelect === 'add_to_invoice'
                                  ? invoicesDraft
                                  : invoicesAll}
                              </Field>
                            </div>
                          )
                        }
                      </WatchField>
                    </div>
                  </div>
                  <div>
                    <ul className="nav nav-pills pull-right">
                      <li>
                        <Button
                          variant="outlined"
                          className={classes.button}
                          onClick={cancel}
                        >
                          {t('asiakkaat.perut')}
                        </Button>
                      </li>
                      <li>
                        <Button
                          variant="contained"
                          className={classes.button}
                          type="submit"
                          disabled={
                            type === 'allowance' &&
                            decisionSelect === 'add_to_payroll' &&
                            hasInvalidSelectedAllowance
                          }
                        >
                          {t('decisionDialog.submitButton')}
                        </Button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </Form>
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            open={
              type === 'allowance' &&
              decisionSelect === 'add_to_payroll' &&
              hasInvalidSelectedAllowance
            }
            autoHideDuration={2000}
          >
            <MySnackbarContentWrapper
              variant="error"
              message={t('expences.msgMinKm')}
              noCloseIcon
            />
          </Snackbar>
        </div>
      )}
    </Translation>
  )
}

const generateMenuItem = (item, index) => (
  <MenuItem
    key={index}
    value={item.invoice_id}
    disabled={item.is_group_invoice}
  >
    {item.invoice_id +
      ' ' +
      item.company_name +
      ' ' +
      new DateTimeFormat('fi', {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric'
      }).format(new Date(item.due_date)) +
      ' ' +
      (item.total_sum == null ? 0 : item.total_sum) +
      ' € ' +
      '(' +
      convertIntToState(item.status, 'userView') +
      ')'}
  </MenuItem>
)

AddToInvoiceDialog.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(AddToInvoiceDialog)
